import { Alert, Button, Divider, Group, Stack } from "@mantine/core"
import { ChatHeaderGroup } from "../../../../-components/chat/ChatHeaderGroup"
import { DefaultInfiniteList } from "../../../../../-components/InfiniteList"
import { useDefaultSuspenseInfiniteQuery } from "../../../../../utils/useDefaultSuspenseInfiniteQuery"
import { FeedPostCard } from "./FeedPostCard"
import { useDisclosure } from "@mantine/hooks"
import { useGetAuthenticatedUser } from "../../../-components/use-authenticated-user"
import { FeedSubscribeIcon } from "./FeedSubscribeIcon"
import { NewPostModal } from "./NewPostModal"
import { useTranslation } from "react-i18next"
import {
  getFeedPosts,
  getGetFeedPostsQueryKey,
  useGetChatByIdSuspense,
} from "@/orval/gen"

interface Props {
  chatId: number
}

export function FeedView({ chatId }: Props) {
  const { t } = useTranslation("app_server")
  const { data: chat } = useGetChatByIdSuspense({
    chatId: chatId,
  })

  const [
    isNewPostModalOpen,
    { open: openNewPostModal, close: closeNewPostModal },
  ] = useDisclosure()

  const queryResult = useDefaultSuspenseInfiniteQuery(
    getFeedPosts,
    (pageRequest) => ({
      chatId,
      ...pageRequest,
    }),
    { queryKey: getGetFeedPostsQueryKey({ chatId }) }
  )

  if (!chat) return <Alert color="red">Feed not found</Alert>

  const currentUserId = useGetAuthenticatedUser().data.userId
  const userMember = chat.chatMembers.find((cm) => cm.userId === currentUserId)
  const userCanPost = !chat.isReadOnly || userMember?.isAdmin

  return (
    <Stack flex="1" p="sm">
      <ChatHeaderGroup
        chatId={chatId}
        rightSection={
          <Group justify="space-between">
            {chat.chatType === "Feed" && !userMember?.isAdmin && (
              <FeedSubscribeIcon subscribed={!!userMember} id={chatId} />
            )}
            {userCanPost && (
              <Button
                onClick={(evt) => {
                  evt.stopPropagation()
                  openNewPostModal()
                }}
              >
                {t("NewPost")}
              </Button>
            )}
          </Group>
        }
      />
      <NewPostModal
        chatId={chatId}
        onClose={closeNewPostModal}
        opened={isNewPostModalOpen}
      />
      <Divider />
      <DefaultInfiniteList
        flex="1"
        selectable
        align="center"
        queryResult={queryResult}
        gap="sm"
        renderItem={({ entity }) => (
          <FeedPostCard hideComments={"collapsed"} feedPost={entity} />
        )}
      />
    </Stack>
  )
}
